import { useState } from "react";
import {
	ComboBoxContainer,
	ComboBoxInput,
	ComboBoxList,
	ComboBoxListItem,
	ComboBoxBackdrop,
} from "./style";

export function Combobox({
	value,
	label,
	options,
	onChange,
	disabled,
	placeholder,
	loading,
	secondDescription,
	description,
	hasImage,
	image,
	className = "",
}) {
	const [showOptions, setShowOptions] = useState(false);
	return (
		<ComboBoxContainer className={className}>
			<label htmlFor="combobox">{label}</label>
			<ComboBoxInput
				name="combobox"
				value={value}
				type="text"
				onChange={(e) => onChange({ e })}
				disabled={disabled}
				placeholder={placeholder}
				onFocus={() => setShowOptions(true)}
			/>
			{showOptions && loading ? (
				<ComboBoxList>
					<ComboBoxListItem>Carregando...</ComboBoxListItem>
				</ComboBoxList>
			) : (
				showOptions && (
					<ComboBoxList>
						{options.length > 0 ? (
							options.map((option, index) => (
								<ComboBoxListItem
									key={index}
									onClick={() => {
										onChange({ option });
										setShowOptions(false);
									}}
								>
									<div className="flex">
										{hasImage && (
											<img
												src={option[image]}
												alt={option[description]}
												width="50"
												height="50"
											/>
										)}
										<p>{option[description]}</p>
									</div>
									<p className="sm">
										{option[secondDescription] ? ` ${option[secondDescription]}` : ""}
									</p>
								</ComboBoxListItem>
							))
						) : (
							<ComboBoxListItem>Sem resultados...</ComboBoxListItem>
						)}
					</ComboBoxList>
				)
			)}
			{showOptions && <ComboBoxBackdrop onClick={() => setShowOptions(false)} />}
		</ComboBoxContainer>
	);
}
